module.exports = "https://www.gc-pro.gnp.com.mx/eb95e0ea249673fa1ff03341e6c759b5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/arrow-next.svg
// module id = 8059
// module chunks = 0